module.exports = __webpack_public_path__ + "img/exchange.0193f318.png";